import styled from "styled-components";
import { fadeIn } from "styles/effects";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: end;
  width: 100%;
  gap: 10px;
  overflow: visible;
  animation: 0.9s ${fadeIn} forwards;
  box-sizing: border-box;
`;
